//import axios from 'axios';
import jwtDecode from 'jwt-decode';
import router from '../router/index.js';

const authModule = {
  async checkTokenStatus() {
    const token = window.sessionStorage.getItem("token");
    alert("token: "+token);
    if (token) {
      const decodedToken = jwtDecode(token);
//      alert("decodedToken: "+decodedToken);
      const currentTime = Date.now() / 1000;
      alert(" decodedToken.exp: "+decodedToken.exp+"  <  currentTime: "+currentTime);

      const tiempoRestante = decodedToken.exp - currentTime;

      alert("TIEMPO: " + tiempoRestante);      

      if (decodedToken.exp < currentTime) {
            alert("El token ha expirado");
/*            
            try {
              const resp = await axios.post('http://localhost:8080/api/v1/refreshToken', token)
              const nuevoToken = resp.data.result.token;
              alert("uevoToken"+nuevoToken);
              console.log("INFORMACIÓN: "+nuevoToken);
              axios.defaults.headers.common['Authorization'] = `Bearer ${nuevoToken}`;        
              window.sessionStorage.setItem('token', resp.data.result.token);
          }
          catch (error) {
            this.mensaje = "Error de autenticación";
            this.mensaje02 = error;
            window.sessionStorage.removeItem("token");
          }        
*/          
      } else {
        alert("El token es válido");
      }
    } else {
        alert("No hay token almacenado");
        router.push('/Login');
    }
  },
};

export default authModule;